import React from "react";
// import Link from 'next/link'
import { connect } from "react-redux";
// import { Divider } from '@mui/material'
import { withStyles } from "@mui/styles";
// import Typography from '@mui/material/Typography'
// import dhl from 'public/image/couriers/dhl.svg'
// import chinaEms from 'public/image/couriers/china-ems.svg'
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const styles = (theme) => ({
  tableRow: {
    height: 38,
  },
  headCell: {
    padding: "8px 8px !important",
    height: 38,
    minWidth: 108,
    borderBottom: "1px solid #f7f7f7",
    // backgroundColor: '#000000',
    // color: '#000000',
    // color: 'rgba(0, 0, 0, 0.87)'
  },
  cell: {
    padding: "8px 8px !important",
    height: 38,
    width: 118,
    borderBottom: "1px solid #f7f7f7",
  },
});

class TemplateSetRate extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //
  }

  render() {
    const { classes, rate } = this.props;

    return (
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow
            classes={{
              root: classes.tableRow,
            }}
          >
            <TableCell
              classes={{
                root: classes.headCell,
              }}
              align="left"
              variant="head"
            ></TableCell>
            {rate.prices.map((price, index) => {
              return (
                <TableCell
                  key={index}
                  classes={{
                    root: classes.headCell,
                  }}
                  align="left"
                  variant="head"
                >
                  {price.zone_name}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            classes={{
              root: classes.tableRow,
            }}
          >
            <TableCell
              classes={{
                root: classes.cell,
              }}
              align="left"
              variant="body"
            >
              First product
            </TableCell>
            {rate.prices.map((price, index) => {
              return (
                <TableCell
                  key={index}
                  classes={{
                    root: classes.cell,
                  }}
                  align="left"
                  variant="body"
                >
                  $ {price.first_price}
                </TableCell>
              );
            })}
          </TableRow>
          <TableRow
            classes={{
              root: classes.tableRow,
            }}
          >
            <TableCell
              classes={{
                root: classes.cell,
              }}
              align="left"
              variant="body"
            >
              Additional product
            </TableCell>
            {rate.prices.map((price, index) => {
              return (
                <TableCell
                  key={index}
                  classes={{
                    root: classes.cell,
                  }}
                  align="left"
                  variant="body"
                >
                  $ {price.additional_price}
                </TableCell>
              );
            })}
          </TableRow>
        </TableBody>
      </Table>
    );
  }
}

function mapStateToProps(state) {
  const { app, dashboard } = state;
  return { app, dashboard };
}

export default connect(mapStateToProps)(withStyles(styles)(TemplateSetRate));
